import { attendeeFetchData, attendeeSendData } from "./index";

const eventFollowUpAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/evaluation-questions/followup`),
  send: (attendeeId, data) => attendeeSendData(`/api/v2/attendees/${attendeeId}/evaluation-questions/followup`, data),
}

export default eventFollowUpAPI;